"use client";

import { cn } from "@devhop/ui";
import type { ReactNode } from "react";

export type ChartConfig = Record<
  string,
  {
    label?: string;
    color?: string;
  }
>;

type ChartContainerProps = {
  config: ChartConfig;
  children: ReactNode;
  className?: string;
};

export function ChartContainer({
  config: _config,
  children,
  className,
}: ChartContainerProps) {
  return (
    <div
      className={cn("w-full", className)}
      style={
        {
          "--color-chart-1": "var(--chart-1)",
          "--color-chart-2": "var(--chart-2)",
          "--color-chart-3": "var(--chart-3)",
          "--color-chart-4": "var(--chart-4)",
          "--color-chart-5": "var(--chart-5)",
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
}
